import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaymentState } from "./payment.state";
import { initiatePayment } from "./payment.thunk";
import { InitiatePaymentResponse } from "./payment.types";

const initialState: PaymentState = {
  data: null,
  status: "idle",
  error: null,
  isInitiatingPayment: false,
  htmlContent: null,
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    resetPayment: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
      state.isInitiatingPayment = false;
      state.htmlContent = null;
    },
  },
  extraReducers: (build) => {
    build
      .addCase(initiatePayment.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.isInitiatingPayment = true;
      })
      .addCase(
        initiatePayment.fulfilled,
        (state, action: PayloadAction<InitiatePaymentResponse>) => {
          state.status = "success";
          state.data = action.payload.data;
          state.isInitiatingPayment = false;
          if (action.payload.data && "html_content" in action.payload.data) {
            state.htmlContent = action.payload.data.html_content;
          } else {
            state.htmlContent = null;
          }
        }
      )
      .addCase(
        initiatePayment.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Ödeme başlatılırken bir hata oluştu.";
          state.isInitiatingPayment = false;
        }
      );
  },
});

export const { resetPayment } = paymentSlice.actions;

export default paymentSlice.reducer;